import { useEffect, useState } from "react";
import './serverDash.css' 
import { useAuth } from '../AuthContext';
import { useNavigate} from "react-router-dom";

function GuildButtonManager({ item, botServers, handleCancelSub, handleInvite, handleSubscribeNow }) {
    const [isLoading, setIsLoading] = useState(true);
    const [hasSubscription, setHasSubscription] = useState(false);
    const [isCanceled, setIsCanceled] = useState(false);
    const isBotInServer = botServers.includes(item.id);

    useEffect(() => {
        if (!isBotInServer) {
            setIsLoading(false);
            return;
        }

        let isMounted = true;

        const checkMembership = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/api/check_guild_membership', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ guildID: item.id }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                if (isMounted) {
                    const sub_id = data[0]?.sub_id || null; 
                    const purchased_by = data[0]?.purchased_by || null;
                    const cancel_sub_date = data[0]?.cancel_sub_date || null;
                    setHasSubscription(sub_id && purchased_by);
                    setIsCanceled(!!cancel_sub_date); // Check if cancel_sub_date exists
                }
            } catch (error) {
                console.error(`Failed to check membership for ${item.name}:`, error);
                if (isMounted) {
                    setHasSubscription(false);
                }
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        checkMembership();

        return () => {
            isMounted = false; 
        };
    }, [item.id, isBotInServer]);

    if(isCanceled){
        return <button disabled>Subscription Cancelled</button>;
    }
    
    if (!isBotInServer) {
        return <button onClick={() => handleInvite()}>Invite Bot</button>;
    }

    if (isLoading) {
        return <button disabled>Loading...</button>;
    }

    if (isBotInServer && !hasSubscription) {
        return <button onClick={() => handleSubscribeNow()}>Subscribe Now!</button>;
    }

    if (isBotInServer && hasSubscription) {
        return <button onClick={() => handleCancelSub(item.id)}>Cancel Subscription</button>;
    }

    return null;
}

function ServerDash() {

    const [botServers, SetBotServers] = useState([]);

    const [loading, setLoading] = useState(true)

    const { loggedIn, userID, userName, guildList } = useAuth();  
    const navigate = useNavigate();
    
    const handleSubscribeNow = (guildId) => {
        console.log(`Opening Stripe checkout for guild ID: ${guildId}`);
        window.open(`https://buy.stripe.com/test_fZucN52zta9Q4A28RFgnK02?client_reference_id=${encodeURIComponent(userID + '_' + guildId)}`, "_blank");    }

    const handleCancelSub = (guildId) => {
        console.log(`Canceling subscription for guild ID: ${guildId}`);

        fetch('/api/cancel_guild_subscription', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ guildID: guildId }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return response.json();
        })
        .then(data => {
            console.log(`Subscription canceled for guild ID ${guildId}:`, data);
            navigate('/server_dash');
        })
        .catch(error => {
            console.error("Error canceling subscription:", error);
        });
    }

    const handleInvite = () => {
        window.open("https://discord.com/oauth2/authorize?client_id=1382543634930339870&permissions=2151148608&integration_type=0&scope=bot", "_blank");
    }

    useEffect(() => {
        if (!loggedIn) {
            window.location.href = '/';
        }
    }, [loggedIn]);

    useEffect(() => {
        // Define an async function inside the effect
        const fetchData = async () => {

            try {
                const response = await fetch('/api/get_bot_guilds');



                if (!response.ok) {
                    let errorMessage = `HTTP error fetching get_bot_guilds! status: ${response.status}`;
                    let errorDetails = `Status: ${response.status}`;

                    try {
                        // Try to parse JSON first, then text
                        const errorData = await response.json(); 
                        errorDetails = JSON.stringify(errorData);
                        console.error(`Server Error Response (get_bot_guilds):`, errorData);
                    } catch (jsonError) {
                        try {
                            const errorText = await response.text(); 
                            errorDetails = errorText;
                            console.error(`Server Error Response (get_bot_guilds):`, errorText);
                        } catch (textError) {
                            errorDetails += `, Could not read error response body.`;
                            console.error(`Server Error (get_bot_guilds). Could not read response body`);
                        }
                    }

                    errorMessage += `, Error: ${errorDetails}`;
                    const err = new Error(errorMessage);
                    err.status = response.status;
                    throw err; // Throw the constructed error
                }

                // If response is OK, parse the JSON data
                const guildData = await response.json();
                console.log(guildData)
                const botServerIds = guildData.map((guild) => String(guild.guild_id)); // Assuming `guild_id` is the correct field
                SetBotServers(botServerIds); // Update state with all IDs
            } catch (err) {
                console.error("Fetch operation failed:", err);
            } 
        };

        fetchData(); 

    }, []); 
    useEffect(() => {
        if(loading && botServers.length > 0){
            setLoading(false)
        }
    }, [botServers])

    const loadGuildButtons = (item) => {
        if (loading) {
            return null; 
        }

        if (botServers.includes(item.id)) {
            fetch('/api/check_guild_membership', { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify({ guildID: item.id }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // Parse the JSON response
            }).then(data => {
                console.log(`Guild membership check for ${item.name}:`, data);
                return (
                    <button onClick={() => handleCancelSub(item.id)}>Manage Subscription</button>
                );
            })

        } else {
            return (
                <button onClick={() => handleInvite()}>Invite Bot</button>
            );
        }
    };
    return (
        <div className="dash-wrapper">
            <h1 className="header-text">{userName}'s Server Dashboard</h1>
            {loading ? (
                <p>Loading guild data...</p> 
            ) : (
                <div className="guild-grid">
                    {guildList.map((item) => {
                        const getInitials = (name) => {
                            return name
                                .split(' ')
                                .filter(word => word.length > 0)
                                .map((word) => word[0])
                                .join('')
                                .toUpperCase();
                        };

                        return (
                            <div key={item.id} className="guild-box">
                                <h3>{item.name}</h3>
                                <div className="guild-icon-container">
                                    {item.icon ? (
                                        <img
                                            className="guild-icon"
                                            src={`https://cdn.discordapp.com/icons/${item.id}/${item.icon}.png`}
                                            alt={`${item.name} icon`}
                                        />
                                    ) : (
                                        <div className="guild-icon-placeholder">
                                            {getInitials(item.name)}
                                        </div>
                                    )}
                                </div>
                                <div className="button-container">
                                    <GuildButtonManager 
                                        item={item} 
                                        botServers={botServers} 
                                        handleCancelSub={handleCancelSub} 
                                        handleInvite={handleInvite} 
                                        handleSubscribeNow={handleSubscribeNow}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
  };

  export default ServerDash;